import { pxToRem } from '../../../../utils';
/** ChatItem styles specific for the default/comfy density. */

export var chatItemStylesComfy = {
  root: function root(_ref) {
    var p = _ref.props;
    return Object.assign({}, (!p.attached || p.attached === 'top') && {
      paddingTop: pxToRem(16)
    }, (p.attached === 'bottom' || p.attached === true) && {
      paddingTop: pxToRem(2)
    });
  },
  gutter: function gutter(_ref2) {
    var _ref3;

    var p = _ref2.props,
        v = _ref2.variables;
    return _ref3 = {
      marginTop: v.gutterMargin
    }, _ref3[p.contentPosition === 'end' ? 'right' : 'left'] = 0, _ref3;
  },
  message: function message(_ref4) {
    var v = _ref4.variables;
    return {
      marginLeft: v.messageMargin,
      marginRight: v.messageMargin
    };
  }
};